export const MODEL = 'gpt-realtime';
// export const VOICE = 'verse';
export const VOICE = 'marin';

// Shared base behavior, independent of verbosity mode
export const BASE_DIRECTIVE = `
You are a voice assistant for healthcare professionals, focused on managing patient visits, providing key insights, and assisting with documentation and billing.
Your top priority is to streamline the provider's workflow with accurate, clinically appropriate information.

Example Capabilities & Responses (Only when asked about):
“What can you do?”
  Provide a concise response summarizing your capabilities:
  Example “I can help you manage patient visits, pull up your next patient, provide key insights, start a new visit, complete you notes, observe Range of motion values, and review your chart before finalizing.”
“Who's my next patient?”
  Retrieve and state the next scheduled patient's NAME ONLY if you have it; otherwise say “I don't know.”
  Example: “[NAME]”
“Is there anything I should know about them?”
  Fetch and summarize key details from the patient's chart, such as recent conditions, red flags, or prior concerns. (ONLY IF YOU HAVE IT!!!)
  Example: "[NAME] is coming in for rehab on a torn rotator cuff. This is his 4th visit in a 10 week track ”
“Is there a better way to bill this session?”
  Analyze the documentation for billing accuracy and suggest improvements. (ONLY IF YOU HAVE IT!!!)
  Example: “It looks like you're about to bill Therapeutic Exercise, but if you make it functional, we can bill Therapeutic Activities, which will reimburse better and aligns with your practice's policy.”
`;

// Verbosity-specific response rules
const ULTRA_CONCISE_RULES = `
ULTRA-CONCISE RESPONSE RULES:
- Respond with **one short line or less** (a fragment is fine); no filler, no small talk, no repetition.
- If a direct answer exists, give just that answer (e.g., name, value, yes/no, short phrase).
- Only add brief context when absolutely necessary to avoid confusion.
- Do NOT explain your reasoning unless explicitly asked to, and even then keep it to one short line.
`;

const MEDIUM_RULES = `
MEDIUM VERBOSITY RESPONSE RULES:
- Respond in **exactly one clear sentence** unless explicitly asked for more.
- Prioritize the single most important point; avoid side notes and long enumerations.
- Only mention reasoning if it fits naturally in that one sentence.
`;

const NORMAL_RULES = `
NORMAL VERBOSITY RESPONSE RULES:
- Respond as fully as is helpful, with multiple sentences and examples when useful.
- Briefly explain your reasoning for non-trivial answers.
- You may ask clarifying questions when needed.
`;

// Assembled directives for each verbosity mode
export const SYSTEM_DIRECTIVE_ULTRA = `${BASE_DIRECTIVE}\n${ULTRA_CONCISE_RULES}`;
export const SYSTEM_DIRECTIVE_MEDIUM = `${BASE_DIRECTIVE}\n${MEDIUM_RULES}`;
export const SYSTEM_DIRECTIVE_NORMAL = `${BASE_DIRECTIVE}\n${NORMAL_RULES}`;

// This is disabled in Synapse brain (Bookmark: // CONTEXT (DISABLED FOR DEMO ONLY!!!))
export const FAKE_PRIMER = `
Schedule: Jake, Bob, Alice, Dave, Emily, Sarah, Tom
Next Patient: Jake (26 year old male coming in following a post op shoulder injury. He tore his right rotator cuff and is recovering well. This is his 6th appointment of a 10 week track.)
`;

// # This is disabled in ConversationDetailsNative and ConversationDetailsCX
export const FAKE_TRANSCRIPT = `Date of visit: 2025-02-12
Patient: Jacob Michalski



Jake has 3 out of 10 shoulder pain in the right shoulder currently, 1 out of 10 pain at best, and 7 out of 10 pain at worst, and no history of shoulder pain in the past. The patient is a dull and aching type pain in the front of the shoulder. He has been doing his HEP as prescribed. He is taking 600 milligram ibuprofen 1 time per day to allow him to work out. The shoulder does feel better with ice, rest, and medication. It does feel the worst to sleep on my right side.  Patients blood pressure is 120 over 70. His right shoulder appears to be elevated and slightly routed compared to the left.. He tends to be a little guarded and slightly flexed upon standing. His right shoulder flexion is 150 degrees, left shoulder flexion is 180 degrees, right shoulder external rotation is 70 degrees, left shoulder external rotation is 90 degrees, extension is 10 degrees on the right. Right shoulder internal rotation is 40 degrees and painful, left shoulder internal rotation is 50 degrees. Right shoulder abduction is 145 degrees with pain, Left shoulder abduction is 175 degrees. Right shoulder extension 15 degrees and painful, left shoulder extension 30 degrees. 
elbow flexion range of motion is 120 degrees bilaterally and elbow extension range of motion is 0 degrees bilaterally. 
Thoracic rotation to the right is 35 degrees and thoracic rotation to the left is 49 degrees.
The DASH score was a 28
And shoulder extension on the left is 30 degrees. Right shoulder flexion, strength testing is four to five. Left shoulder flexion, five out of five. Right shoulder internal rotation, four out of five. Right shoulder external rotation, three out of five. Left shoulder internal and external rotation is five out of five each. Grip strength and the power grip is 50 pounds on the right and 80 pounds on the left. myotomes on the upper extremity, right and left are all normal. Median nerve test on the right, negative. Ulnar nerve test on the right, negative. Radial nerve test on the right, negative.
Empty can test negative on the right. Drop arm test negative on the right. Hawkins Kennedy test positive on the right shoulder. Tender to palpation, anterior right shoulder.
We are going to see you 2 times per week for the next 4 weeks to keep improving your strength and range of motion in the shoulder. 

Started with unattended electric stimulation for 15 min to the right shoulder girdle 
We did glenohumeral joint mobilizations grade 3 and 4 to improve range of motion, sidelying external rotation with 5 pound dumbbell 2 sets 10 reps, standing scaption raises 2 sets 10 reps with 5 reps, and suit case carries with 20 pound dumbbell 2 sets 10 steps. 
`;
